/*
  Sväto · Aperçu couleur au survol des pastilles (voir assets/CUSTOM.txt).
  Cartes concernées :
    - carte native du thème (<product-card>, pastilles .swatch-link[data-href]) : accueil,
      page collection, « Vous aimerez aussi » ;
    - carte Sväto (.svato-card, pastilles [data-swatch][data-img]) : collections canapé, vus récemment.
  Au survol d'une pastille (souris uniquement), la photo de la variante de cette couleur s'affiche
  par-dessus le visuel de la carte ; la photo « au survol de la carte » est neutralisée pendant ce temps.
  En quittant les pastilles, la carte revient à son visuel d'origine. Le clic garde son comportement.
  Un seul écouteur délégué au document : fonctionne aussi pour les cartes chargées après coup.
*/
const productCache = new Map(); // url produit -> Promise<Map<variantId, imageUrl>>

function variantImages(productUrl) {
  const key = productUrl.split('?')[0];
  if (!productCache.has(key)) {
    productCache.set(
      key,
      fetch(`${key}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((p) => {
          const map = new Map();
          for (const v of p.variants || []) {
            const src = v.featured_image?.src;
            if (src) map.set(String(v.id), sized(src, 900));
          }
          return map;
        })
        .catch(() => new Map())
    );
  }
  return productCache.get(key);
}

function sized(src, width) {
  try {
    const url = new URL(src, location.origin);
    url.searchParams.set('width', String(width));
    return url.href;
  } catch {
    return src;
  }
}

function preload(src) {
  if (!src) return;
  const img = new Image();
  img.decoding = 'async';
  img.src = src;
}

/** Retourne { card, media, getSrc } pour une pastille survolée, ou null. */
function resolve(target) {
  const nativeSwatch = target.closest('product-card .swatch-link[data-href]');
  if (nativeSwatch) {
    const card = nativeSwatch.closest('product-card');
    const media = card.querySelector('.product-card-media-gallery__media, product-card-media-gallery .splide__slide.is-active, product-card-media-gallery');
    const variantId = new URL(nativeSwatch.dataset.href, location.origin).searchParams.get('variant');
    const productUrl = card.dataset.productUrl || nativeSwatch.dataset.href;
    return { swatch: nativeSwatch, card, media, getSrc: () => variantImages(productUrl).then((m) => m.get(variantId)) };
  }
  const svatoSwatch = target.closest('.svato-card [data-swatch]');
  if (svatoSwatch) {
    const card = svatoSwatch.closest('.svato-card');
    return { swatch: svatoSwatch, card, media: card.querySelector('.svato-card__media'), getSrc: () => Promise.resolve(svatoSwatch.dataset.img) };
  }
  return null;
}

function overlayFor(card, media) {
  let layer = media.querySelector(':scope > .svato-sw-preview');
  if (!layer) {
    layer = document.createElement('img');
    layer.className = 'svato-sw-preview';
    layer.alt = '';
    layer.setAttribute('aria-hidden', 'true');
    layer.decoding = 'async';
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.append(layer);
  }
  return layer;
}

let current = null; // { card, token }

async function show(target) {
  const hit = resolve(target);
  if (!hit || !hit.media) return;
  const token = Symbol('preview');
  current = { card: hit.card, token };
  // La photo « au survol de la carte » disparaît tout de suite, sans attendre la photo de la couleur.
  hit.card.classList.add('is-swatch-preview');
  const src = await hit.getSrc();
  if (!src || current?.token !== token) return;
  const layer = overlayFor(hit.card, hit.media);
  if (layer.getAttribute('src') !== src) {
    layer.classList.remove('is-visible');
    layer.src = src;
    await layer.decode().catch(() => {});
    if (current?.token !== token) return;
  }
  hit.card.classList.add('is-swatch-preview');
  layer.classList.add('is-visible');
}

function hide(card) {
  if (!card) return;
  card.classList.remove('is-swatch-preview');
  card.querySelectorAll('.svato-sw-preview').forEach((l) => l.classList.remove('is-visible'));
  if (current?.card === card) current = null;
}

const SWATCH = 'product-card .swatch-link[data-href], .svato-card [data-swatch]';
const ROW = 'product-card-swatches, .svato-card__swatches';

document.addEventListener('pointerover', (e) => {
  if (e.pointerType !== 'mouse') return;
  // Dès qu'on approche des pastilles : on charge les photos de la carte pour un affichage immédiat.
  const row = e.target.closest(ROW);
  if (row && !row.dataset.swPreloaded) {
    row.dataset.swPreloaded = '1';
    row.querySelectorAll('[data-img]').forEach((b) => preload(b.dataset.img));
    const card = row.closest('product-card');
    if (card?.dataset.productUrl) variantImages(card.dataset.productUrl).then((m) => m.forEach(preload));
  }
  if (e.target.closest(SWATCH)) show(e.target);
});

document.addEventListener('pointerout', (e) => {
  if (e.pointerType !== 'mouse') return;
  const from = e.target.closest(ROW);
  if (!from) return;
  // Pastille → pastille voisine : on garde l'aperçu (le pointerover suivant le remplace).
  if (e.relatedTarget && from.contains(e.relatedTarget) && e.relatedTarget.closest(SWATCH)) return;
  if (e.relatedTarget && e.relatedTarget.closest(SWATCH)) return;
  hide(from.closest('product-card, .svato-card'));
});

// Clavier : même aperçu au focus d'une pastille.
document.addEventListener('focusin', (e) => {
  if (e.target.closest(SWATCH) && e.target.matches(':focus-visible')) show(e.target);
});
document.addEventListener('focusout', (e) => {
  const sw = e.target.closest(SWATCH);
  if (sw && !(e.relatedTarget && e.relatedTarget.closest(SWATCH))) hide(sw.closest('product-card, .svato-card'));
});

// Carte Sväto : après un clic, la couleur choisie devient le visuel de base.
document.addEventListener('click', (e) => {
  const sw = e.target.closest('.svato-card [data-swatch]');
  if (sw) hide(sw.closest('.svato-card'));
});
